import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

export const SENSOR_TYPES = ['FRIDGE', 'ROOM'] as const
export type SensorType = (typeof SENSOR_TYPES)[number]

const zSensorForm = z
  .object({
    description: z
      .string()
      .max(500, {
        message: 'La description doit comporter au maximum 500 caractères.',
      })
      .optional(),
    fridgeId: z.number().optional(),
    label: z
      .string()
      .nonempty({ message: 'Le libellé est requis.' })
      .max(100, { message: 'Le libellé doit comporter au maximum 100 caractères.' }),
    model: z
      .string()
      .max(100, { message: 'Le modèle doit comporter au maximum 100 caractères.' })
      .optional(),
    reference: z
      .string()
      .max(50, { message: 'La référence du capteur doit comporter au maximum 50 caractères.' })
      .optional(),
    storeId: z.number().optional(),
    temperatureOffset: z.number().optional(),
    tempMinOverride: z.number().nullable().optional(),
    tempMaxOverride: z.number().nullable().optional(),
    breachToleranceMinutesOverride: z.number().nullable().optional(),
    inactivityThresholdMinutesOverride: z.number().nullable().optional(),
    type: z.enum(SENSOR_TYPES),
  })
  .superRefine((data, ctx) => {
    if (data.type === 'FRIDGE') {
      if (data.fridgeId === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Le réfrigérateur est requis.',
          path: ['fridgeId'],
        })
      }
    }
    if (data.type === 'ROOM') {
      if (data.storeId === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Le magasin est requis.',
          path: ['storeId'],
        })
      }
    }
  })

export type SensorForm = z.infer<typeof zSensorForm>

export const useSensorForm = (defaultValues?: Partial<SensorForm>) => {
  const form = useForm<SensorForm>({
    defaultValues: {
      description: '',
      fridgeId: undefined,
      label: '',
      model: '',
      reference: '',
      storeId: undefined,
      temperatureOffset: 0,
      tempMinOverride: undefined,
      tempMaxOverride: undefined,
      breachToleranceMinutesOverride: undefined,
      inactivityThresholdMinutesOverride: undefined,
      type: 'FRIDGE',
      ...defaultValues,
    },
    resolver: zodResolver(zSensorForm),
  })

  return form
}
